import React from "react";
import "./TestimonialsSection.css";
import { useTranslation } from "react-i18next";

const TestimonialsSection = () => {
  const { t } = useTranslation();

  return (
    <div className="testimonials-section">
      <h2 className="section-title">{t("testimonials_section.title")}</h2>

      <div className="iframe-wrapper">
        <iframe
          height="600px"
          id="testimonialto-acefund-tag-all-light-animated"
          src="https://embed-v2.testimonial.to/w/acefund?animated=on&theme=light&shadowColor=ffffff&speed=0.75&tag=all"
          frameBorder="0"
          scrolling="no"
          width="100%"
          title="AceFund Testimonials"
        ></iframe>
      </div>
    </div>
  );
};

export default TestimonialsSection;

// import React from "react";
// import "./TestimonialsSection.css";
// import { useTranslation } from "react-i18next";
// import gilbert from "./assets/gilbert.PNG";
// import garry from "./assets/garry.jpg";
// import selfbar from "./assets/selfbar.jpg";

// // Exemple de données (Tu pourras les remplacer par tes vrais témoignages)
// const testimonials = [
//   {
//     id: 1,
//     name: "Selfbar team",
//     profilePic: selfbar,
//     stars: 5,
//     text: "We raised €500.000 in 2023 and €2 Millions in 2024 using ACE fund, it's the right tool to onboard investors. ACE Fund did many introductions as well. We don't know how could did it without ACE Fund.",
//     date: "Oct 21, 2024",
//     type: "text",
//   },
//   {
//     id: 2,
//     name: "Gilbert REVEILLON",
//     profilePic: gilbert,
//     stars: 5,
//     text: "Tockenisation has a great future but with ACE Fund it reaches new heights and leveraging years of EntertainmentTech Industry achievements! Here is the launch of a word premiere at CES Las Vegas 2024 in my village CES 2024 WEB3 tokenization !! So the sclae for these state of the heart achievements is beyond 10/10 :-) ",
//     image: gilbert,
//     date: "Jul 2, 2024",
//     type: "image",
//   },
//   //   {
//   //     id: 3,
//   //     name: "Laurence Haxaire",
//   //     stars: 5,
//   //     video:
//   //       "https://assets.mixkit.co/videos/preview/mixkit-man-working-on-his-laptop-308-large.mp4", // Vidéo exemple (libre de droit)
//   //     text: "Investir ensemble n'a jamais été aussi simple.",
//   //     date: "20 Nov 2025",
//   //     type: "video",
//   //   },
//   {
//     id: 4,
//     name: "Laurence Haxiare",
//     profilePic: "https://i.pravatar.cc/150?u=JeanD",
//     stars: 5,
//     text: "Ca ne suffit pas de dire qu'il faut changer le système: Il faut aggir en ce sens. ACE Fund est un outil qui s'adapte à chaque projet ayant besoin d'être financé, et offre l'opportunité à tout investisseur de s'impliquer au-delà du gest financier. les entrepreuneurs ''ré-enchanteur'' trouvent en ACE FUnd une solution innovante, up to date, excitante...",
//     date: "Jul 4, 2024",
//     type: "text",
//   },
//   {
//     id: 5,
//     name: "Léonie N.",
//     profilePic: "https://i.pravatar.cc/150?u=JeanD",
//     stars: 5,
//     text: "I have known ACE Fund for a couple of years now and they still continue to amaze me by the quality of their services. Top notch founder as well.",
//     date: "SEp 30, 2024",
//     type: "text",
//   },
//   {
//     id: 6,
//     name: "Garry Yankson",
//     profilePic: garry,
//     stars: 5,
//     text: "ACE Fund is assisting us in raising funds for two different projects. The system is amazing. We dit not know that such solutions existed. We recommend it to anyone embarking on a fundraising campaign, especially in Music and Cine",
//     date: "Jul 2, 2024",
//     type: "text",
//   },
// ];

// const StarRating = () => <div className="stars">{"★".repeat(5)}</div>;

// const TestimonialCard = ({ item }) => {
//   return (
//     <div className="testimonial-card">
//       <div className="card-header">
//         <div className="user-info">
//           {/* Si pas d'image, on met un rond gris par défaut */}
//           <img
//             src={
//               item.profilePic ||
//               "https://upload.wikimedia.org/wikipedia/commons/7/7c/Profile_avatar_placeholder_large.png"
//             }
//             alt={item.name}
//             className="profile-pic"
//           />
//           <span className="user-name">{item.name}</span>
//         </div>
//         <span className="card-date">{item.date}</span>
//       </div>

//       <StarRating />

//       <div className="card-content">
//         {/* Cas : Image */}
//         {item.image && (
//           <div className="media-container">
//             <img src={item.image} alt={item.name} className="testimonial-img" />
//           </div>
//         )}

//         {/* Cas : Vidéo */}
//         {item.video && (
//           <div className="media-container video-container">
//             <video
//               src={item.video}
//               autoPlay
//               muted
//               loop
//               playsInline
//               className="testimonial-video"
//             />
//           </div>
//         )}

//         {/* Cas : Texte */}
//         {item.text && <p className="testimonial-text">"{item.text}"</p>}
//       </div>
//     </div>
//   );
// };
// const TestimonialsSection = () => {
//   const { t } = useTranslation();

//   return (
//     <div className="testimonials-section">
//       <h2 className="section-title">{t("testimonials_section.title")}</h2>

//       <div className="marquee-wrapper">
//         {/* Le dégradé pour l'effet cinéma */}
//         <div className="fade-overlay fade-left"></div>
//         <div className="fade-overlay fade-right"></div>

//         {/* Le conteneur qui bouge */}
//         <div className="marquee-track">
//           {/* On double la liste pour créer la boucle infinie parfaite */}
//           {testimonials.map((item) => (
//             <TestimonialCard key={`original-${item.id}`} item={item} />
//           ))}
//           {testimonials.map((item) => (
//             <TestimonialCard key={`duplicate-${item.id}`} item={item} />
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TestimonialsSection;
